export default "__VITE_ASSET__BT2lvPaL__"